<div class="modal" [class.show]="isVisible" [style.display]="isVisible ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="accessibilityModalLabel" aria-hidden="!isVisible">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="accessibilityModalLabel">
          <i class="fas fa-universal-access mr-2"></i>
          Opciones de Accesibilidad
        </h5>
        <button type="button" class="btn btn-sm btn-light close-btn buttonOption" (click)="Cerrar()" aria-label="Cerrar" data-gtm-group="accessibility">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label font-weight-bold">
            <i class="fas fa-font mr-2"></i>
            Tamaño de fuente
          </label>
          <p class="text-muted small mb-3">
            Selecciona el tamaño de fuente que prefieras para una mejor lectura.
          </p>
          <div class="font-size-slider-container">
            <input
              type="range"
              min="0"
              max="3"
              step="1"
              [value]="getSliderValue(configuracionActual.fontSize)"
              (input)="onSliderChange($event.target.value)"
              class="font-size-slider"
            />
            <div class="font-size-slider-labels d-flex justify-content-between mt-2">
              <span
                *ngFor="let opcion of opcionesFuente; let idx = index"
                [class.selected]="configuracionActual.fontSize === opcion.value"
                (click)="onSliderChange(idx)">
                {{ opcion.label }}
              </span>
            </div>
            <div class="font-preview mt-3" [ngClass]="'preview-' + configuracionActual.fontSize">
              {{ getSample(configuracionActual.fontSize) }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary buttonOption" (click)="RestablecerPorDefecto()" data-gtm-group="accessibility">
          <i class="fas fa-undo mr-2"></i>
          Restablecer
        </button>
        <button type="button" class="btn btn-primary buttonOption" (click)="Guardar()" data-gtm-group="accessibility">
          <i class="fas fa-check mr-2"></i>
          Aplicar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop" [class.show]="isVisible" *ngIf="isVisible" (click)="Cerrar()"></div>
